import React from "react";
import { estimateVACompensation, estimateHigh3Retirement, money } from "@/lib/claimUtils";
import { CurrencyDollar, Wallet, FirstAid } from "@phosphor-icons/react";

export default function FinancialsView({ profile, setProfile, financials, setFinancials, combined }) {
  const va = estimateVACompensation(combined.rounded, profile.maritalStatus, profile.minorDependents);
  const retired = estimateHigh3Retirement(financials.high3Average, financials.yearsService, financials.monthsService);

  return (
    <div className="view-grid" data-testid="financials-view">
      {/* Summary cards */}
      <div className="fin-summary" data-testid="fin-summary">
        <div className="fin-card" data-testid="fin-va-comp">
          <CurrencyDollar size={24} weight="duotone" className="fin-icon" />
          <div className="fin-amount mono">{money(va.monthly)}</div>
          <div className="fin-sublabel">VA COMP / MONTH</div>
          <div className="fin-basis">{va.basis}</div>
        </div>
        <div className="fin-card" data-testid="fin-high3">
          <Wallet size={24} weight="duotone" className="fin-icon" />
          <div className="fin-amount mono">{money(retired.monthly)}</div>
          <div className="fin-sublabel">HIGH-3 / MONTH</div>
          <div className="fin-basis">{(retired.multiplier * 100).toFixed(2)}% multiplier</div>
        </div>
        <div className="fin-card fin-card--total" data-testid="fin-total">
          <FirstAid size={24} weight="duotone" className="fin-icon" />
          <div className="fin-amount mono">{money(va.monthly + retired.monthly)}</div>
          <div className="fin-sublabel">COMBINED / MONTH</div>
          <div className="fin-basis">{money((va.yearly + retired.yearly))}/yr</div>
        </div>
      </div>

      {/* Inputs */}
      <div className="panel" data-testid="fin-inputs-panel">
        <div className="panel-header">
          <CurrencyDollar size={18} weight="bold" />
          <span>FINANCIAL INPUTS</span>
        </div>
        <div className="panel-body">
          <div className="field-grid">
            <label className="field">
              <span className="field-label">HIGH-3 AVG MONTHLY PAY</span>
              <input className="field-input mono" type="number" value={financials.high3Average} onChange={(e) => setFinancials({ ...financials, high3Average: e.target.value })} placeholder="e.g. 6000" data-testid="fin-high3-input" />
            </label>
            <label className="field">
              <span className="field-label">YEARS OF SERVICE</span>
              <input className="field-input mono" type="number" value={financials.yearsService} onChange={(e) => setFinancials({ ...financials, yearsService: Number(e.target.value || 0) })} data-testid="fin-years-input" />
            </label>
            <label className="field">
              <span className="field-label">MONTHS OF SERVICE</span>
              <input className="field-input mono" type="number" value={financials.monthsService} onChange={(e) => setFinancials({ ...financials, monthsService: Number(e.target.value || 0) })} data-testid="fin-months-input" />
            </label>
            <label className="field">
              <span className="field-label">MARITAL STATUS</span>
              <select className="field-input" value={profile.maritalStatus} onChange={(e) => setProfile({ ...profile, maritalStatus: e.target.value })} data-testid="fin-marital-input">
                <option>Single</option>
                <option>Married</option>
              </select>
            </label>
            <label className="field">
              <span className="field-label">MINOR DEPENDENTS</span>
              <input className="field-input mono" type="number" min="0" value={profile.minorDependents} onChange={(e) => setProfile({ ...profile, minorDependents: Number(e.target.value || 0) })} data-testid="fin-dependents-input" />
            </label>
            <label className="field">
              <span className="field-label">RETIREMENT STATUS</span>
              <select className="field-input" value={profile.retirementStatus || "Not retired"} onChange={(e) => setProfile({ ...profile, retirementStatus: e.target.value })} data-testid="fin-retirement-input">
                <option>Not retired</option>
                <option>Active duty retiring soon</option>
                <option>Retired</option>
                <option>Medically retired</option>
                <option>Reserve retired</option>
              </select>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
}
